import { Box, Flex, Stack, Text } from "@xcorejs/ui";
import { ReactNode, useEffect, useRef, useState } from "react";
import { Skeleton } from "@mui/joy";
import IconBox from "design-system/xcore/IconBox";

export type SpecificationBoxProps = {
  name: string;
  description: ReactNode;
  icon: string;
};

const SpecificationBox = ({ name, description, icon, ...props }: SpecificationBoxProps) => {
  const [showLoading, setShowLoading] = useState<boolean>(true);

  const imgRef = useRef<HTMLImageElement | null>(null);

  // Check on mount if the image is already loaded from cache
  useEffect(() => {
    if (imgRef.current?.complete) {
      setShowLoading(false);
    }
  }, []);

  return (
    <Flex alignItems="flex-start" {...props}>
      <IconBox
        width="5rem"
        height="5rem"
        minWidth="5rem"
        minHeight="5rem"
        background="robe"
        icon={
          <Box width="5rem" height="5rem" position="relative">
            {showLoading && (
              <Skeleton
                variant="circular"
                width="100%"
                height="100%"
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                }}
              />
            )}
            <img
              ref={imgRef}
              onLoad={() => setShowLoading(false)}
              style={{ background: "#fff", fill: "#e00034" }}
              width="100%"
              height="100%"
              src={icon}
              alt={icon}
            />
          </Box>
        }
      />
      <Stack ml="2rem" gap="0.2rem" direction="column">
        <Text variant="strong" fontSize="1.5rem" lineHeight="2rem">
          {name}
        </Text>
        <Text fontSize="1.5rem" lineHeight="2rem" wordBreak="break-word">
          {description}
        </Text>
      </Stack>
    </Flex>
  );
};

export default SpecificationBox;
